<template>
    <div class="text-center white">
      <v-dialog v-model="dialog" max-width="700" persistent class="white">
        <v-card>
            <v-card-text class="pa-8">
                <h4>
                  Confirmar la desvinculación de la factura. Esta acción <b>NO anula la factura</b> registrada en la DGI; su finalidad es permitir la generación de una nueva. La factura anterior deberá ser anulada directamente en el sistema de la DGI por el personal autorizado
                </h4>
                <p class="text-center purple--text">
                  <b>Primero debe generar la nota de credito correspondiente a esta factura</b>
                </p>
                <div class="row mt-8">
                    <div class="col-xs-12 col-sm-6">
                    <v-btn color="white" :loading="loading" class="red text-white" dark outlined tile @click="desvincularFactura()"> confirmar desvinculación </v-btn>
                    </div>
                    <div class="col-xs-12 col-sm-6">
                    <v-btn color="white" :loading="loading" class="grey text-white" dark outlined tile @click="cerrar()"> Cerrar </v-btn>
                    </div>
                </div>
            </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </template>
  
  <script> 
import { anularFacturaNulRecibo } from './facturafacil';
import { getUserData,setAccessToken } from '@/accessToken.js'  

  export default {
      data() {
        return {
          loading: false,
          dialog: false,
          emitir_refresh: false,
          url: null,
          recibo: {},
          resolvePromise: null,
        };
      },
      methods: {
        async openmodal(prog) { 
          window.console.log('recibo ispi:::::', prog);
          this.dialog = true; 
          this.recibo = prog   
          this.emitir_refresh = false  
          return new Promise((resolve) => {
              this.resolvePromise = resolve;
          });
        },
        cerrar() { 
            this.dialog = false;
            this.resolvePromise(this.emitir_refresh);
        }, 
        async enviar(){ 
            
        },
        async desvincularFactura(){
            const iduser = this.$store.state.DATA_USER.id
            // mariela, diana, fabiola
            const perm = iduser == 43 || iduser == 46812 || iduser == 34099 || iduser ==  8920
            if(!perm){
                this.$root.$notify.show(`No tienes permitido realizar esta acción.`, {
                    color: 'red',
                    x: 'right',
                });
                return
            }

            const ex = getUserData(); 
            if( ex ){  
              const u = JSON.parse(ex);
              const myHeaders = new Headers();
              myHeaders.append('Content-Type', 'application/json');
              const raw = JSON.stringify({ username: u.user, password: u.clave });
              const requestOptions = { method: 'POST', headers: myHeaders, body: raw };
              const rr = await fetch(process.env.VUE_APP_AUTH_POST, requestOptions).then((response) => response.json()).then((data)=>data).catch(e=>e)
              if(rr && rr.ok){
                const token = rr.accessToken 
                setAccessToken(token)
              }
            } 

            this.loading = true
            const r = await anularFacturaNulRecibo(this.recibo)
            this.loading = false
            window.console.log('rrrr::::', r.data );
            if(r && r.data && r.data.data){
                this.$emit('fact_dgi_success')
                this.$root.$notify.show(r.data.data, {
                    color: 'green',
                    x: 'right',
                });
                this.emitir_refresh = true
                this.cerrar()
                return
            }
            
        }
      },
    };
  </script>
  